import React from 'react';
import '../../App.scss';
import { Button, Modal, Accordion, Badge, Card } from 'react-bootstrap'; // Badge ve Card eklendi
import AuthorizedPage from '../../component/AuthorizedPage';
import { Role } from '../../domain/Role';
import ShipmentApi from '../../api/ShipmentApi';
import TruckFormation, { FormationPoint } from '../../component/TruckFormation';
// İkonlar güncellendi
import { FaTruck, FaUser, FaBarcode, FaWarehouse, FaMapMarkerAlt, FaBoxOpen } from 'react-icons/fa';

interface State {
  shipments: any[];
  loading: boolean;
  error: string | null;

  // Modal için
  showDetailModal: boolean;
  detailFormationPoints: FormationPoint[];
  detailLoadedItems: any[];
  totalLoadedItems: any[];
  detailShipment: any | null;
  selectedLayer: number;
  tfHeight: number | null;
}

class ShipmentHistory extends React.Component<any, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      shipments: [],
      loading: false,
      error: null,

      showDetailModal: false,
      detailFormationPoints: [],
      detailLoadedItems: [],
      totalLoadedItems: [],
      detailShipment: null,
      selectedLayer: 1,
      tfHeight: null,
    };
  }

  componentDidMount() {
    this.loadHistory();
  }

  loadHistory = async () => {
    this.setState({ loading: true, error: null });
    try {
      const response = await ShipmentApi.listByStatus("DELIVERY_COMPLETED");
      if (response?.success) {
        this.setState({ shipments: response.data || [] });
      } else {
        this.setState({ error: "Sevkiyat geçmişi alınamadı: " + (response?.error || "") });
      }
    } catch (err) {
      console.error(err);
      this.setState({ error: "Sevkiyat geçmişi alınırken hata oluştu." });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleOpenDetail = async (shipment: any) => {
    this.setState({ loading: true });
    try {
      const formationResp = await ShipmentApi.listVehicleFormationPoints(shipment.vehicleId);
      const loadedResp = await ShipmentApi.listLoadedItems(shipment.id);

      this.setState({
        detailShipment: shipment,
        detailFormationPoints: formationResp?.success ? formationResp.data : [],
        detailLoadedItems: loadedResp?.success ? loadedResp.data.loadedOrderItemDTOS : [],
        totalLoadedItems: loadedResp?.success ? loadedResp.data.totalLoadedOrderItemDTOS : [],
        showDetailModal: true,
        selectedLayer: 1,
      });
    } catch (err) {
      console.error(err);
      alert("Detaylar alınırken hata oluştu.");
    } finally {
      this.setState({ loading: false });
    }
  };

  handleCloseDetail = () => {
    this.setState({
      showDetailModal: false,
      detailShipment: null,
      detailFormationPoints: [],
      detailLoadedItems: [],
      totalLoadedItems: [],
      selectedLayer: 1,
    });
  };

  setLayer = (layer: number) => this.setState({ selectedLayer: layer });

  getProductsForPallet = (palletIndex: number) => {
    return (this.state.detailLoadedItems || []).filter((i: any) => i.palletIndex === palletIndex);
  };

  renderDetailModal = () => {
    const { detailShipment, detailFormationPoints, detailLoadedItems, showDetailModal, selectedLayer } = this.state;
    if (!detailShipment) return null;

    const layers = Array.from(new Set(detailFormationPoints.map(p => p.layer))).sort((a, b) => a - b);

    // --- YENİ EKLENEN KISIM: Unique Target Warehouses ---
    // Ürünlerin içindeki targetWarehouse alanlarını tarar, "-" olanları ve boşları eler, unique listeyi çıkarır.
    const uniqueDestinations = Array.from(new Set(
      (detailLoadedItems || [])
        .map((item: any) => item.targetWarehouse)
        .filter((w: any) => w && w !== "-")
    ));

    return (
      <Modal
        show={showDetailModal}
        onHide={this.handleCloseDetail}
        size="xl"
        dialogClassName="modal-90w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Sevkiyat Detayları</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Üst Bilgi Alanı */}
          <div className="mb-3 p-3 bg-light rounded border">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h5 className="mb-0">
                {detailShipment.shipmentCode} &nbsp;
                <Badge bg="success">{detailShipment.statusDetail?.label || detailShipment.status}</Badge>
              </h5>
              <span className="text-muted small">
                {detailShipment.modifiedAt ? new Date(detailShipment.modifiedAt).toLocaleString() : "-"}
              </span>
            </div>

            <div className="row">
              <div className="col-md-4">
                <div><FaTruck className="text-primary me-2" /> <strong>Araç:</strong> {detailShipment.vehicleDescription}</div>
                <div><FaUser className="text-warning me-2" /> <strong>Şoför:</strong> {detailShipment.driverFullName}</div>
              </div>
              <div className="col-md-4">
                <div><FaWarehouse className="text-secondary me-2" /> <strong>Çıkış:</strong> {detailShipment.fromWarehouseName || detailShipment.fromWarehouseId}</div>
                <div><FaMapMarkerAlt className="text-danger me-2" /> <strong>Varış (Ana):</strong> {detailShipment.toWarehouseName || detailShipment.toWarehouseId}</div>
              </div>
              <div className="col-md-4">
                {/* Unique Teslimat Noktaları */}
                <div>
                  <strong>Teslimat Noktaları:</strong>
                  {uniqueDestinations.length > 0 ? (
                    <div className="d-flex flex-wrap gap-1 mt-1">
                      {uniqueDestinations.map((dest: any, idx) => (
                        <Badge key={idx} bg="info" text="dark">{dest}</Badge>
                      ))}
                    </div>
                  ) : (
                    <span className="text-muted ms-2 fst-italic">-</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div style={{ display: 'flex', gap: 20 }}>
            {/* SOL: Formasyon Görseli */}
            <Card style={{ flex: 1 }}>
              <div
                ref={(el) => {
                  if (el && el.clientHeight !== this.state.tfHeight) {
                    this.setState({ tfHeight: el.clientHeight });
                  }
                }}
              >
                <div className="p-2 fw-bold bg-light border-bottom">
                  Palet Formasyonu (Görüntü)
                </div>

                <div className="p-3">
                  <div className="mb-2">
                    {layers.map(layer => (
                      <Button
                        key={layer}
                        size="sm"
                        variant={selectedLayer === layer ? 'primary' : 'outline-primary'}
                        onClick={() => this.setLayer(layer)}
                        className="me-1"
                      >
                        {layer}. Kat
                      </Button>
                    ))}
                  </div>

                  <TruckFormation
                    formationPoints={detailFormationPoints}
                    selectedBoxIndex={undefined}
                    onBoxClick={undefined}
                    layer={selectedLayer}
                  />
                </div>
              </div>
            </Card>

            {/* SAĞ: Listeler */}
            <Card
              style={{
                width: "50%",
                height: this.state.tfHeight || "600px", // Yükseklik yoksa default verelim
                display: "flex",
                flexDirection: "column",
                overflow: "hidden"
              }}
            >
              {/* --- ÜST: TOPLAM ÜRÜN MİKTARLARI (40%) --- */}
              <div style={{ flex: 0.4, display: "flex", flexDirection: "column", minHeight: 0, borderBottom: '1px solid #ddd' }}>
                <div className="p-2 fw-bold bg-light border-bottom">
                  <FaBoxOpen className="me-2" />Toplam Ürün Miktarları
                </div>

                <div className="overflow-auto p-2">
                  {this.state.totalLoadedItems?.length ? (
                    this.state.totalLoadedItems.map((t: any, index: number) => (
                      <div key={index} className="d-flex justify-content-between border-bottom py-1">
                        <span>{t.productName}</span>
                        <strong>{t.quantity} Adet</strong>
                      </div>
                    ))
                  ) : (
                    <div className="text-muted small">Toplam ürün verisi bulunmuyor.</div>
                  )}
                </div>
              </div>

              {/* --- ALT: PALET İÇERİĞİ (60%) --- */}
              <div style={{ flex: 0.6, display: "flex", flexDirection: "column", minHeight: 0, backgroundColor: '#fafafa' }}>
                <div className="p-2 fw-bold bg-light border-bottom">
                  Palet İçeriği
                </div>

                <div className="overflow-auto p-2">
                  {Array.from(new Set((detailFormationPoints || []).map(p => p.palletIdx)))
                    .filter((x): x is number => x !== undefined)
                    .sort((a, b) => a! - b!)
                    .map((palletIdx: number) => {
                      const palletItems = this.getProductsForPallet(palletIdx);
                      if (palletItems.length === 0) return null;

                      return (
                        <Card key={palletIdx} className="mb-3 shadow-sm border-0">
                          <Card.Header className="py-1 px-2 bg-warning bg-opacity-25 fw-bold text-dark" style={{ fontSize: '0.9rem' }}>
                            Palet #{palletIdx}
                          </Card.Header>
                          <Card.Body className="p-2">
                            <ul className="list-unstyled mb-0">
                              {palletItems.map((item: any, idx: number) => (
                                <li key={idx} className="mb-2 border-bottom pb-2 last-no-border">
                                  {/* Ürün Adı */}
                                  <div className="fw-bold text-primary" style={{ fontSize: '0.9rem' }}>
                                    {item.productName}
                                  </div>

                                  {/* Detay Satırı */}
                                  <div className="d-flex justify-content-between align-items-end mt-1">
                                    {/* Sol: Müşteri ve Hedef */}
                                    <div className="d-flex flex-column small">
                                      <span className="text-dark fw-semibold">
                                        <FaUser size={10} className="me-1 text-muted" />
                                        {item.buyerTitle || "Serbest"}
                                      </span>
                                      {item.targetWarehouse && item.targetWarehouse !== "-" && (
                                        <span className="text-danger mt-1">
                                          <FaMapMarkerAlt size={10} className="me-1" />
                                          {item.targetWarehouse}
                                        </span>
                                      )}
                                    </div>

                                    {/* Sağ: Miktar */}
                                    <div className="text-end">
                                      <Badge bg="secondary" className="text-white">
                                        {item.quantity} Adet
                                      </Badge>
                                    </div>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          </Card.Body>
                        </Card>
                      );
                    })}
                </div>
              </div>

            </Card>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleCloseDetail}>Kapat</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  renderShipments = () => {
    return (
      <Accordion defaultActiveKey="0" style={{ marginTop: "20px" }}>
        {this.state.shipments.map((shipment: any) => (
          <Accordion.Item eventKey={String(shipment.id)} key={shipment.id}>
            <Accordion.Header>
              <div className="d-flex justify-content-between align-items-center w-100">
                <div className="d-flex align-items-center gap-3">
                  <FaTruck size={18} color="#007bff" />
                  <span style={{ fontWeight: 600 }}>{shipment.vehicleDescription}</span>
                </div>

                <div className="d-flex align-items-center gap-3">
                  <FaBarcode color="#28a745" size={16} />
                  <span>{shipment.shipmentCode}</span>
                </div>

                <div className="d-flex align-items-center gap-2">
                  <FaUser color="#ffc107" size={16} />
                  <span>{shipment.driverFullName}</span>
                </div>
                <div className="text-muted small mb-1">
                  Tamamlanma Tarihi: {shipment.modifiedAt ? new Date(shipment.modifiedAt).toLocaleString() : "-"}
                </div>

                <div className="d-flex gap-2">
                  <Button
                    size="sm"
                    variant="secondary"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleOpenDetail(shipment);
                    }}
                  >
                    Detaylı İncele
                  </Button>
                </div>
              </div>
            </Accordion.Header>

            <Accordion.Body>
              <div className="row">
                <div className="col-md-6">
                  <Card className="mb-2 p-2 shadow-sm border-0 bg-light">
                    <div><strong>Durum:</strong> <Badge bg="info">{shipment.statusDetail?.label}</Badge></div>
                    <div><strong>Toplam Ürün Adedi:</strong> {shipment.totalItemCount ?? "-"}</div>
                    <div><strong>Beklenen Ağırlık:</strong> {shipment.expectedWeightInTons ?? "-"}</div>
                    <div><strong>Yüklenen Ağırlık:</strong> {shipment.loadedWeightInTons ?? "-"}</div>
                    <div><strong>Yükleyen:</strong> {shipment.modifiedBy ?? "-"}</div>
                  </Card>
                </div>
                <div className="col-md-6">
                  <Card className="mb-2 p-2 shadow-sm border-0 bg-light">
                    <div><FaWarehouse size={14} className="text-muted" /> <strong>Başlangıç:</strong> {shipment.fromWarehouseName || shipment.fromWarehouseId}</div>
                    <div><FaWarehouse size={14} className="text-muted" /> <strong>Varış:</strong> {shipment.toWarehouseName || shipment.toWarehouseId}</div>
                    <div><strong>Mesafe:</strong> {shipment.routeDistance ?? "-"}</div>
                    {/* Ara depolar varsa göster */}
                    {(shipment.intermediateWarehouse1Name || shipment.intermediateWarehouse1Id) && (
                      <div><strong>Ara Depo 1:</strong> {shipment.intermediateWarehouse1Name || shipment.intermediateWarehouse1Id}</div>
                    )}
                    {(shipment.intermediateWarehouse2Name || shipment.intermediateWarehouse2Id) && (
                      <div><strong>Ara Depo 2:</strong> {shipment.intermediateWarehouse2Name || shipment.intermediateWarehouse2Id}</div>
                    )}
                  </Card>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    );
  };

  render() {
    return (
      <AuthorizedPage role={Role.WAREHOUSE_STAFF}>
        <div className="centered-95-percent">
          <h2 className="mb-3 border-bottom pb-2">Sevkiyat Geçmişi</h2>
          {this.state.error && <div className="alert alert-danger">{this.state.error}</div>}
          {this.renderShipments()}
          {this.renderDetailModal()}
        </div>
      </AuthorizedPage>
    );
  }
}

export default ShipmentHistory;